// extracted by mini-css-extract-plugin
export var author = "testimonial-slider-module--author--GFW42";
export var logo = "testimonial-slider-module--logo--ffs-g";
export var quote = "testimonial-slider-module--quote--Wx3QX";
export var singleTestimonial = "testimonial-slider-module--single-testimonial--whaN9";